package com.dotdrives.web.pages.nextsteps

import react.FC
import react.Props
import react.dom.html.ReactHTML.style

private val nextStepsStyles = """
    .ns-page { min-height: calc(100vh - 118px); }
    .ns-header { display: flex; flex-direction: column; gap: 12px; margin-bottom: 16px; }
    .ns-header-row { display: flex; align-items: center; justify-content: space-between; gap: 14px; flex-wrap: wrap; }
    .ns-title { font-family: 'Quicksand', sans-serif; font-size: 22px; font-weight: 700; }
    .ns-header-actions { display: flex; gap: 10px; }
    .ns-tabs { display: flex; gap: 6px; flex-wrap: wrap; }
    .ns-tab {
      border: 1.5px solid #D6DBE0; color: #5A6870; background: white; font-size: 12px; font-weight: 800;
      padding: 6px 14px; border-radius: 99px; cursor: pointer;
    }
    .ns-tab-active { border-color: #222D32; color: white; background: #222D32; }
    .ns-inline-banner { margin-bottom: 12px; }

    .ns-grid { display: grid; grid-template-columns: 1.5fr 1fr; gap: 16px; align-items: start; }
    @media (max-width: 1080px) {
      .ns-grid { grid-template-columns: 1fr; }
    }

    .ns-section-label {
      font-family: 'IBM Plex Mono', monospace; font-size: 11px; letter-spacing: 1px; margin-bottom: 8px; color: var(--dot-muted);
    }
    .ns-section-label-overdue { color: #C22C25; }
    .ns-skeleton-list { display: flex; flex-direction: column; gap: 10px; margin-bottom: 18px; }

    .ns-card {
      background: white; border: 1px solid #E4E8EC; border-radius: 14px; padding: 15px 18px; margin-bottom: 14px;
      display: flex; align-items: flex-start; gap: 12px;
    }
    .ns-card-overdue { border-color: #F5B5A5; }
    .ns-card-box {
      width: 26px; height: 26px; border-radius: 8px; border: 2px solid #D6DBE0; background: white; cursor: pointer;
      flex-shrink: 0; margin-top: 2px; color: white; font-size: 13px; display: flex; align-items: center; justify-content: center;
    }
    .ns-card-box-overdue { border-color: #C22C25; }
    .ns-card-box:hover { border-color: #00A65A; }
    .ns-card-box:focus-visible { outline: 2px solid var(--dot-focus); outline-offset: 2px; }
    .ns-card-body { flex: 1; min-width: 0; }
    .ns-card-text { font-weight: 800; font-size: 14.5px; margin-bottom: 3px; line-height: 1.3; }
    .ns-card-meta { font-size: 12px; color: var(--dot-muted); margin-bottom: 9px; }
    .ns-card-meta-due { color: #C22C25; font-weight: 800; }
    .ns-card-actions { display: flex; gap: 7px; flex-wrap: wrap; position: relative; }
    .ns-pill-btn {
      border: 1.5px solid #E4E8EC; color: #5A6870; background: white; font-size: 11.5px; font-weight: 800;
      padding: 5px 12px; border-radius: 99px; cursor: pointer;
    }
    .ns-pill-btn-primary { border: none; background: var(--dot-action); color: white; padding: 6px 13px; }
    .ns-pill-btn:focus-visible { outline: 2px solid var(--dot-focus); outline-offset: 2px; }

    .ns-row-list { display: flex; flex-direction: column; gap: 8px; margin-bottom: 20px; }
    .ns-row {
      background: white; border: 1px solid #E4E8EC; border-radius: 12px; padding: 12px 16px;
      display: flex; align-items: center; gap: 12px; position: relative;
    }
    .ns-row:hover, .ns-row:focus-within { border-color: #F26223; }
    .ns-row-controls { display: flex; align-items: center; gap: 8px; }
    .ns-row-body { flex: 1; min-width: 0; }
    .ns-row-text { font-weight: 800; font-size: 13.5px; }
    .ns-row-meta { font-size: 11.5px; color: var(--dot-muted); margin-top: 1px; }
    .ns-row-due { font-family: 'IBM Plex Mono', monospace; font-size: 11px; color: var(--dot-muted); width: 56px; text-align: right; flex-shrink: 0; }
    .ns-row-due-urgent { color: #C22C25; font-weight: 500; }
    .ns-row-more {
      color: var(--dot-muted); background: transparent; border: none; cursor: pointer; font-size: 15px; padding: 2px 6px; flex-shrink: 0;
    }
    .ns-row-more:hover { color: #5A6870; }
    .ns-row-more:focus-visible, .ns-pill-btn:focus-visible, .ns-tab:focus-visible, .ns-toggle:focus-visible {
      outline: 2px solid var(--dot-focus); outline-offset: 2px;
    }

    .ns-popover {
      position: absolute; z-index: 30; top: calc(100% + 6px); right: 0; width: 220px; padding: 8px;
      border-radius: 16px; background: white; box-shadow: 0 16px 50px rgba(34,45,50,.22);
      animation: ns-pop-in 140ms ease both;
    }
    .ns-popover-left { left: 0; right: auto; }
    .ns-popover-item {
      width: 100%; text-align: left; padding: 9px 12px; font-size: 13px; font-weight: 800; border-radius: 9px;
      color: #222D32; background: transparent; border: none; cursor: pointer;
    }
    .ns-popover-item:hover { background: #F7F8FA; }
    .ns-popover-item-active { background: #FEF8F6; color: var(--dot-action-text); }
    .ns-popover-item-meta { font-size: 10.5px; color: var(--dot-muted); font-weight: 700; }

    @keyframes ns-pop-in { from { transform: translateY(8px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

    .ns-health-card { background: white; border: 1px solid #E4E8EC; border-radius: 16px; padding: 18px 20px; margin-bottom: 16px; }
    .ns-health-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 4px; gap: 8px; }
    .ns-health-title { font-family: 'Quicksand', sans-serif; font-size: 15px; font-weight: 700; }
    .ns-health-sub { font-size: 11.5px; color: var(--dot-muted); margin-bottom: 12px; }
    .ns-health-list { display: flex; flex-direction: column; gap: 10px; }
    .ns-health-item { border: 1px solid #E4E8EC; border-radius: 12px; padding: 11px 14px; }
    .ns-health-item-head { display: flex; justify-content: space-between; margin-bottom: 5px; gap: 8px; }
    .ns-health-item-name { font-weight: 800; font-size: 13px; }
    .ns-health-item-meta { font-family: 'IBM Plex Mono', monospace; font-size: 10.5px; }
    .ns-health-track { height: 5px; background: #EFF1F4; border-radius: 3px; overflow: hidden; margin-bottom: 7px; }
    .ns-health-fill { height: 100%; border-radius: 3px; background: var(--dot-tone-accent, #F26223); }
    .ns-health-suggest { font-size: 11.5px; color: #5A6870; }

    .ns-automation-card { background: #222D32; color: white; border-radius: 16px; padding: 18px 20px; }
    .ns-automation-title { font-family: 'Quicksand', sans-serif; font-size: 15px; font-weight: 700; margin-bottom: 4px; }
    .ns-automation-sub { font-size: 11.5px; color: #A4B1B9; margin-bottom: 14px; }
    .ns-automation-list { display: flex; flex-direction: column; gap: 9px; }
    .ns-automation-item { display: flex; align-items: center; gap: 11px; background: rgba(255,255,255,.06); border-radius: 11px; padding: 10px 13px; }
    .ns-automation-icon { font-size: 15px; }
    .ns-automation-copy { flex: 1; min-width: 0; }
    .ns-automation-name { font-weight: 800; font-size: 12.5px; }
    .ns-automation-rule { font-size: 10.5px; color: #A4B1B9; margin-top: 1px; }
    .ns-toggle {
      width: 34px; height: 20px; border-radius: 99px; position: relative; flex-shrink: 0; border: none; cursor: pointer;
      background: #3D4A52; transition: background 140ms ease;
    }
    .ns-toggle-on { background: #00A65A; }
    .ns-toggle-knob {
      position: absolute; top: 2px; left: 2px; width: 16px; height: 16px; border-radius: 50%; background: white;
      transition: left 140ms ease;
    }
    .ns-toggle-on .ns-toggle-knob { left: 16px; }
    .ns-new-rule-link {
      margin-top: 12px; font-size: 12px; font-weight: 800; color: #F79E78; background: transparent; border: none; cursor: pointer;
    }

    .ns-dialog-backdrop {
      position: fixed; z-index: 40; inset: 0; display: flex; align-items: center; justify-content: center;
      padding: 24px; background: rgba(34,45,50,.34); animation: ns-fade-in 180ms ease both;
    }
    .ns-dialog {
      width: min(500px, 100%); max-height: calc(100vh - 48px); overflow: auto; padding: 26px 30px;
      border-radius: 20px; background: white; box-shadow: 0 24px 80px rgba(34,45,50,.25);
      animation: ns-pop-in-lg 220ms ease both;
    }
    .ns-dialog-title { font-family: 'Quicksand', sans-serif; font-size: 20px; font-weight: 700; margin-bottom: 3px; }
    .ns-dialog-sub { font-size: 12.5px; color: var(--dot-muted); margin-bottom: 16px; }
    .ns-dialog-actions { display: flex; gap: 10px; margin-top: 6px; }
    .ns-dialog-actions .dot-button { flex: 1; }
    .ns-dialog-actions .dot-button:last-child { flex: 2; }

    .ns-composer {
      border: 2px solid #F26223; border-radius: 12px; padding: 12px 15px; font-size: 14px; font-weight: 700;
      margin-bottom: 12px; width: 100%; box-sizing: border-box; outline: none; font-family: inherit; color: #222D32;
      resize: vertical; min-height: 44px;
    }
    .ns-chip-row { display: flex; gap: 7px; flex-wrap: wrap; margin-bottom: 14px; }
    .ns-chip-select {
      border: 1.5px solid #D6DBE0; color: #5A6870; background: white; font-size: 11.5px; font-weight: 800;
      padding: 6px 13px; border-radius: 99px; font-family: inherit; cursor: pointer;
    }
    .ns-chip-select-active { border-color: #F26223; color: var(--dot-action-text); background: #FDE5DA; }

    .ns-subject-label { font-size: 12px; font-weight: 800; margin-bottom: 6px; }
    .ns-subject-search { width: 100%; padding: 10px 14px; border: 1px solid #E4E8EC; border-radius: 12px; outline: none; font-size: 13px; box-sizing: border-box; }
    .ns-subject-search:focus { border-color: #F26223; }
    .ns-subject-results { border: 1px solid #E4E8EC; border-radius: 12px; overflow: hidden; margin-top: 6px; margin-bottom: 14px; }
    .ns-subject-result {
      width: 100%; display: flex; align-items: center; gap: 10px; padding: 10px 14px; border-top: 1px solid #F2F4F6;
      background: white; cursor: pointer; text-align: left;
    }
    .ns-subject-result:first-child { border-top: none; }
    .ns-subject-result:hover { background: #FEF8F6; }
    .ns-subject-selected {
      border: 1px solid #E4E8EC; border-radius: 12px; padding: 10px 14px; display: flex; align-items: center; gap: 10px;
      margin-bottom: 14px;
    }
    .ns-subject-avatar {
      width: 26px; height: 26px; border-radius: 50%; background: #4696EC; color: white; font-weight: 800; font-size: 10px;
      display: flex; align-items: center; justify-content: center; flex-shrink: 0;
    }
    .ns-subject-copy { flex: 1; min-width: 0; }
    .ns-subject-name { font-weight: 800; font-size: 13px; }
    .ns-subject-context { font-size: 10.5px; color: var(--dot-muted); }

    .ns-email-row { display: flex; align-items: center; gap: 9px; margin-bottom: 16px; }
    .ns-email-row .ns-toggle { width: 36px; height: 21px; }
    .ns-email-row .ns-toggle-knob { width: 16px; height: 16px; top: 2.5px; }
    .ns-email-row .ns-toggle-on .ns-toggle-knob { left: 17px; }
    .ns-email-label { font-size: 12.5px; color: #5A6870; font-weight: 700; }

    .ns-rule-name-input { margin-bottom: 14px; }

    .ns-builder-label {
      font-family: 'IBM Plex Mono', monospace; font-size: 10px; color: #5B4AA8; letter-spacing: 1px; margin-bottom: 6px;
    }
    /* Static summary text, not a picker -- there is nothing behind either the WHEN or THEN
       row to select yet, so no `cursor: pointer` or select-shaped affordance here. */
    .ns-builder-summary {
      border: 1px solid #E4E8EC; border-radius: 12px; padding: 12px 15px; font-size: 13.5px; font-weight: 800; width: 100%;
      box-sizing: border-box; background: #F7F8FA; margin-bottom: 10px; color: #222D32;
    }
    .ns-builder-condition-row { display: flex; gap: 7px; margin-bottom: 14px; flex-wrap: wrap; align-items: center; }
    .ns-builder-condition {
      background: #EFF1F4; font-size: 11.5px; font-weight: 800; padding: 6px 13px; border-radius: 99px; display: flex;
      align-items: center; gap: 5px; border: none;
    }
    .ns-builder-amount-input {
      width: 70px; border: none; background: transparent; font-family: inherit; font-size: 11.5px; font-weight: 800;
      outline: none;
    }
    .ns-builder-template {
      border: 1px solid #E4E8EC; border-radius: 12px; padding: 11px 15px; font-size: 13px; margin-bottom: 6px; width: 100%;
      box-sizing: border-box; outline: none; font-family: inherit; resize: vertical; min-height: 60px; color: #222D32;
    }
    .ns-builder-template:focus { border-color: #F26223; }
    .ns-builder-due-row { display: flex; align-items: center; gap: 6px; font-size: 13px; margin-bottom: 14px; color: #222D32; }
    .ns-builder-due-input {
      width: 42px; border: 1px solid #E4E8EC; border-radius: 8px; padding: 4px 6px; font-family: inherit; font-weight: 800;
      text-align: center;
    }
    .ns-builder-preview { background: #F7F8FA; border-radius: 11px; padding: 11px 14px; font-size: 12px; color: #5A6870; margin-bottom: 16px; }
    .ns-builder-error { color: #C22C25; font-size: 12px; font-weight: 700; margin: -8px 0 14px; }

    .ns-all-done { background: #EFF1F4; border-radius: 20px; padding: 52px 44px; box-sizing: border-box; text-align: center; }
    .ns-all-done-emoji { font-size: 46px; margin-bottom: 12px; }
    .ns-all-done-title { font-family: 'Quicksand', sans-serif; font-size: 22px; font-weight: 700; margin-bottom: 8px; }
    .ns-all-done-copy { font-size: 14px; color: #5A6870; line-height: 1.6; max-width: 420px; margin: 0 auto 18px; }
    .ns-all-done-actions { display: flex; gap: 10px; justify-content: center; flex-wrap: wrap; }

    @keyframes ns-fade-in { from { opacity: 0; } to { opacity: 1; } }
    @keyframes ns-pop-in-lg { from { transform: translateY(14px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

    @media (max-width: 620px) {
      .ns-row { flex-wrap: wrap; gap: 8px; }
      .ns-row-body { flex-basis: calc(100% - 42px); }
      .ns-row-controls { width: 100%; flex-wrap: wrap; padding-left: 34px; }
      .ns-row-due { margin-left: auto; width: auto; }
      .ns-page { min-height: calc(100vh - 88px); }
      .ns-dialog { padding: 22px 18px; }
      .ns-dialog-actions { flex-direction: column; }
    }
""".trimIndent()

val NextStepsStyles = FC<Props> {
    style { +nextStepsStyles }
}
